import { accountService } from 'mycorems-app-accounts';
import eventBus from '@/messaging/event-bus';
import { ClientEdited } from '@/messaging/events';

export default {
  edit(id: string, name: string): Promise<void> {
    return accountService.edit(id, name).then(() => {
      eventBus.$emit(ClientEdited.eventName, new ClientEdited(id, name));
    });
  },
};
